module.exports = __webpack_public_path__ + "static/media/icon-tree.5816e658.svg";